import { useEffect } from "react";

const BASE_URL = "https://www.gopigadhvi.com";
const DEFAULT_OG_IMAGE = `${BASE_URL}/assets/social/og-image.png`;

// Minimal, dependency-free SEO manager: sets document title, meta
// description, Open Graph/Twitter tags and a canonical link tag per
// route. Avoids pulling in react-helmet just to update a handful of
// head tags.
const SEO = ({
  title,
  description,
  path = "/",
  image = DEFAULT_OG_IMAGE,
}) => {
  useEffect(() => {
    const fullTitle = title ? `${title} | Gopi Gadhvi Group` : "Gopi Gadhvi Group | Building Trust. Creating Legacy.";
    document.title = fullTitle;

    const setMeta = (name, content, attr = "name") => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    const desc = description || "Gopi Gadhvi Group is a founder-led house of ventures spanning private real estate advisory, interior design, creative arts, digital products and personal transformation.";
    setMeta("description", desc);
    setMeta("og:site_name", "Gopi Gadhvi Group", "property");
    setMeta("og:title", fullTitle, "property");
    setMeta("og:description", desc, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:url", `${BASE_URL}${path}`, "property");
    setMeta("og:image", image, "property");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", desc);
    setMeta("twitter:image", image);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${BASE_URL}${path}`);
  }, [title, description, path, image]);

  return null;
};

export default SEO;
